import { f7 } from 'framework7-react';
import { useCallback } from 'react';
import {
  CheckInReserveDataType,
  LoanerCarEntryItemType,
} from '../../../types/bodyAndPaint';
import { useLoanerCarState } from './hook/state/useLoanerCarState';
import { useStorageItem } from './hook/useStorageItem';
import { CheckInUseLoanerCar } from './loanerCarEntry/checkInUseLoanerCar';
import { PageTemplateComponent } from './util/common/pageTemplate/pageTemplate';
import { paths } from '@/config/paths';

export const CheckInUseLoanerCarPage = () => {
  const { stored: checkInEntries, setStorageItem: setCheckInEntries } =
    useStorageItem<CheckInReserveDataType>({ key: 'checkInReserve' });

  const { loanerCarInfoState, approveCheck, onChangeCheck, disabled } =
    useLoanerCarState({
      initial: checkInEntries?.loanerCarInfo ?? ({} as LoanerCarEntryItemType),
    });

  const handleClickBack = () => {
    f7.views.main.router.navigate(paths.bpsCheckInReserveDate);
  };
  const handleClickNext = useCallback(() => {
    setCheckInEntries((prev) => ({
      ...prev,
      loanerCarInfo: loanerCarInfoState.state,
    }));

    f7.views.main.router.navigate(paths.bpsCheckInReserveConfirm);
  }, [loanerCarInfoState.state, setCheckInEntries]);

  return (
    <PageTemplateComponent
      pageName={'checkInReserve'}
      title={'傷・凹み修理予約'}
      onBack={handleClickBack}
    >
      <CheckInUseLoanerCar
        props={{
          loanerCarInfoState,
          approveCheck,
          onChangeCheck,
        }}
        disabled={disabled}
        onNext={handleClickNext}
      />
    </PageTemplateComponent>
  );
};
